/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PaymentMethodIndexPathParams,
	PaymentMethodIndexQueryParams,
	PaymentMethodIndexResponse,
} from '../types/PaymentMethodIndex'

/**
 * GET /:organisation/payment-methods
 * @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::index
 */
export async function paymentMethodIndex(
	organisation: PaymentMethodIndexPathParams['organisation'],
	params?: PaymentMethodIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PaymentMethodIndexResponse>> {
	return axiosInstance.get(`/${organisation}/payment-methods`, { params, ...config })
}
